import { useEffect, useState } from 'react';

export const useCardIntersectionObserver = (elementRef) => {
	const [entry, setEntry] = useState();

	useEffect(() => {
		const node = elementRef?.current;
		const root = document.querySelector('.compare-item-list');

		if (!window.IntersectionObserver || !node || !root) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((_entry) => {
					setEntry(_entry);
				});
			},
			{
				threshold: [0.05, 0.95],
				root
			}
		);

		observer.observe(node);

		// eslint-disable-next-line consistent-return
		return () => observer.disconnect();
	}, [elementRef]);

	return entry;
};
